<div class="info-card">
    <div class="card-title">{{ title }}</div>
    <div class="card-value">{{ value }}</div>
    <!-- <svg *ngIf="chartSvgPath" class="mini-chart" viewBox="0 0 100 30" preserveAspectRatio="none"> -->
    <svg class="mini-chart" viewBox="0 0 100 30" preserveAspectRatio="none">
      <path [attr.d]="chartSvgPath" stroke="#22c55e" fill="none" stroke-width="2" />
    </svg>
  
    <div class="card-change" [class.positive]="changePositive" [class.negative]="!changePositive">
      <span class="arrow">{{ changePositive ? '▲' : '▼' }}</span> {{ change }}
      <span class="subtext">{{ subtext }}</span>
    </div>
  </div>
  
  